import { FILTER_TYPES } from "../../component/datatable/DataTable";


export const prepareBaseGetListParams = (criteria, addPaginationParams = true) => {
    //console.log('UserService::getList - criteria', criteria)
    const params = new URLSearchParams();

    if (addPaginationParams) {
        params.append('first', criteria.first);
        params.append('max', criteria.rows);        
    }
    params.append('sort_field', criteria.sortField);
    params.append('sort_asc', criteria.sortOrder === 1);
    if (criteria.baseQuery) {
        params.append('search', criteria.baseQuery);
    }    
    if (criteria.filters) {
        Object.keys(criteria.filters).forEach(filterName => {
            const filter = criteria.filters[filterName];
            if (filter.type === FILTER_TYPES.DATE_RANGE || filter.type === FILTER_TYPES.DATE_TIME_RANGE) {  
                if (filter.value?.from) {
                    if (filter.apiValueFromConverter) {
                        params.append(`${filter.apiParamName}_from`, filter.apiValueFromConverter(filter.value.from));
                    } else {
                        params.append(`${filter.apiParamName}_from`, filter.apiValueConverter ? filter.apiValueConverter(filter.value.from) : filter.value.from);
                    }
                    
                }
                if (filter.value?.to) {
                    if (filter.apiValueToConverter) {
                        params.append(`${filter.apiParamName}_to`, filter.apiValueToConverter(filter.value.to));
                    } else {
                        params.append(`${filter.apiParamName}_to`, filter.apiValueConverter ? filter.apiValueConverter(filter.value.to) : filter.value.to);
                    }
                }
            } else if (filter.type === FILTER_TYPES.NUMBER_RANGE) {
                if (filter.value?.from != null) {
                    params.append(`${filter.apiParamName}_from`, filter.value.from);
                }
                if (filter.value?.to != null) {
                    params.append(`${filter.apiParamName}_to`, filter.value.to);
                }
            } else if (filter.type === FILTER_TYPES.AMOUNT) {
                if (filter.value?.from != null) {
                    params.append(`${filter.apiParamName}_from`, filter.value.from);
                }
                if (filter.value?.to != null) {
                    params.append(`${filter.apiParamName}_to`, filter.value.to);
                }
            } else if (filter.type === FILTER_TYPES.LIST) {
                // For LIST type, extract only IDs from the array of objects
                if (Array.isArray(filter.value) && filter.value.length > 0) {
                    if (filter.apiValueConverter) {
                        // Use custom converter if provided
                        params.append(filter.apiParamName, filter.apiValueConverter(filter.value));
                    } else {
                        // Default: extract IDs from the array of objects
                        const ids = filter.value.map(item => item.id || item).join(',');
                        params.append(filter.apiParamName, ids);
                    }
                }
            } else {
                params.append(filter.apiParamName, filter.apiValueConverter ? filter.apiValueConverter(filter.value) : filter.value);
            }        
        })
    }
    return params;
}

export const limitGetListParam = (params, paramName, limit) => {
    const currentValue = params.get(paramName);
    if (!Array.isArray(limit)) {
        return params;
    }
    if (limit.length === 0) {
        params.delete(paramName);
        return params;
    }
    if (currentValue === null) {
        params.set(paramName, limit.join(','));
        return params;
    }
    const existingValues = String(currentValue).split(',')
        .map(v => v.trim())
        .filter(v => v.length > 0);
    const filteredValues = existingValues.filter(v => limit.includes(v));
    if (filteredValues.length > 0) {
        params.set(paramName, filteredValues.join(','));
    } else {
        params.set(paramName, limit.join(','));
    }

    return params;
}